var _rect, _polygon, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagebankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "668.666px",
    height: "91px",
    viewBox: "0 0 668.666 91",
    enableBackground: "new 0 0 668.666 91",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 548.75,
    y: 5.148,
    fill: "#14062E",
    width: 6.151,
    height: 35.816
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#14062E",
    points: "588.337,5.148 588.337,40.964 582.98,40.964 582.98,12.986 582.88,12.986 577.324,40.964  574.348,40.964 568.792,12.986 568.693,12.986 568.693,40.964 563.335,40.964 563.335,5.148 571.421,5.148 575.786,26.083  575.886,26.083 580.251,5.148 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14062E",
    d: "M599.552,40.964h-5.953l6.598-35.815h7.639l6.598,35.815h-5.952l-1.091-7.937h-6.747L599.552,40.964z  M601.535,27.67h4.961l-2.431-15.378h-0.099L601.535,27.67z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1275.67,
    y: -50.03,
    width: 2001.785,
    height: 1606.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14062E",
    d: "M628.473,22.809h10.07v18.156h-2.977l-1.141-2.679 c-1.836,2.183-3.324,3.175-6.201,3.175c-4.86,0-8.233-3.473-8.233-9.177V13.83c0-5.06,2.976-9.177,9.027-9.177 c6.151,0,9.227,4.465,9.227,9.822v2.282h-5.854c0-5.358-1.091-6.747-3.521-6.747c-1.488,0-2.729,0.893-2.729,3.919v18.404 c0,2.282,0.745,3.77,2.878,3.77c2.48,0,3.373-1.389,3.373-4.961V27.67h-3.919V22.809z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14062E",
    points: "646.781,40.964 646.781,5.148 663.25,5.148 663.25,10.506  652.932,10.506 652.932,19.733 660.869,19.733 660.869,25.09 652.932,25.09 652.932,35.607 663.945,35.607 663.945,40.964  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14062E",
    d: "M548.514,45.986h10.988c7.943,0,11.467,4.061,11.467,11.407 c0,3.703-1.553,7.585-5.136,9.018c3.762,1.672,5.972,4.659,5.972,10.213c0,7.107-3.164,12.482-11.586,12.482h-11.705V45.986z  M555.919,63.664h2.688c2.806,0,4.957-1.911,4.957-5.495c0-4.001-1.555-6.092-4.838-6.092h-2.808V63.664z M555.919,83.014h3.105 c3.941,0,5.375-2.27,5.375-6.629c0-4.42-1.672-6.629-6.091-6.629h-2.39V83.014z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14062E",
    d: "M585.061,89.106h-7.167l7.943-43.12h9.197l7.943,43.12h-7.167l-1.313-9.556 h-8.122L585.061,89.106z M587.45,73.1h5.972l-2.926-18.514h-0.12L587.45,73.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14062E",
    points: "609.663,89.106 609.663,45.986 616.531,45.986 625.549,70.651  625.669,70.651 625.669,45.986 632.357,45.986 632.357,89.106 625.908,89.106 616.472,62.171 616.353,62.171 616.353,89.106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#14062E",
    points: "641.552,89.106 641.552,45.986 648.958,45.986 648.958,61.932  649.077,61.932 656.841,45.986 664.247,45.986 656.244,62.051 665.262,89.106 657.737,89.106 651.705,69.039 651.585,69.039  648.958,73.817 648.958,89.106  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -1275.67,
    y: -50.03,
    width: 2001.785,
    height: 1606.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M23.678,44.87h23.226v41.873h-6.864l-2.632-6.178 c-4.233,5.034-7.665,7.322-14.301,7.322c-11.212,0-18.991-8.009-18.991-21.166V24.162c0-11.67,6.863-21.166,20.822-21.166 c14.186,0,21.279,10.297,21.279,22.653v5.263H32.716c0-12.356-2.517-15.56-8.122-15.56c-3.433,0-6.293,2.06-6.293,9.039v42.445 c0,5.263,1.717,8.695,6.637,8.695c5.72,0,7.778-3.203,7.778-11.441v-8.009h-9.038V44.87z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M55.604,24.162c0-11.67,6.863-21.166,21.736-21.166 c14.874,0,21.737,9.496,21.737,21.166v42.559c0,11.67-6.863,21.166-21.737,21.166c-14.873,0-21.736-9.496-21.736-21.166V24.162z  M69.789,66.378c0,6.178,1.832,9.153,7.551,9.153c5.721,0,7.552-2.975,7.552-9.153V24.505c0-6.178-1.831-9.153-7.552-9.153 c-5.719,0-7.551,2.975-7.551,9.153V66.378z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M107.32,24.162c0-11.67,6.865-21.166,21.737-21.166 c14.874,0,21.738,9.496,21.738,21.166v42.559c0,11.67-6.864,21.166-21.738,21.166c-14.872,0-21.737-9.496-21.737-21.166V24.162z  M121.508,66.378c0,6.178,1.83,9.153,7.55,9.153c5.721,0,7.552-2.975,7.552-9.153V24.505c0-6.178-1.831-9.153-7.552-9.153 c-5.72,0-7.55,2.975-7.55,9.153V66.378z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M158.695,4.14h21.051c14.644,0,22.423,8.009,22.423,24.941v32.721 c0,16.932-7.779,24.941-22.423,24.941h-21.051V4.14z M172.881,75.073h4.92c7.551,0,10.184-2.86,10.184-11.555V27.365 c0-8.695-2.633-11.555-10.184-11.555h-4.92V75.073z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    points: "221.741,87.117 221.741,4.514 235.927,4.514 235.927,38.149  251.029,38.149 251.029,4.514 265.215,4.514 265.215,87.117 251.029,87.117 251.029,50.507 235.927,50.507 235.927,87.117  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M274.717,4.514h14.188v62.353c0,6.063,2.401,9.038,7.55,9.038 c5.147,0,7.551-2.975,7.551-9.038V4.514h14.187v61.781c0,14.186-8.237,21.966-21.737,21.966s-21.737-7.78-21.737-21.966V4.514z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    points: "383.867,4.514 383.867,87.117 371.512,87.117 371.512,22.591  371.283,22.591 358.47,87.117 351.604,87.117 338.79,22.591 338.562,22.591 338.562,87.117 326.206,87.117 326.206,4.514  344.854,4.514 354.922,52.794 355.151,52.794 365.219,4.514  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M402.406,87.116h-13.729l15.216-82.602h17.618l15.218,82.602H423l-2.517-18.305 h-15.561L402.406,87.116z M406.983,56.455h11.44l-5.605-35.467h-0.229L406.983,56.455z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    points: "441.309,87.117 441.309,4.514 454.466,4.514 471.74,51.765  471.97,51.765 471.97,4.514 484.783,4.514 484.783,87.117 472.428,87.117 454.351,35.519 454.123,35.519 454.123,87.117  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#14062E",
    d: "M519.912,24.879c-0.572-7.093-4.349-9.153-7.551-9.153 c-4.576,0-7.094,2.975-7.094,8.123c0,14.073,28.83,20.823,28.83,43.246c0,13.615-9.152,21.166-22.423,21.166 c-13.158,0-20.708-10.526-21.28-22.881l13.501-1.946c0.57,8.352,3.89,12.471,8.466,12.471c4.919,0,8.237-2.632,8.237-7.551 c0-16.36-28.831-20.708-28.831-44.39c0-13.157,8.009-20.594,21.967-20.594c11.555,0,18.42,8.352,19.676,20.022L519.912,24.879z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagebankLogo);
export default __webpack_public_path__ + "static/media/imagebank-logo.3eac626e4395548ba1acd62258438e7f.svg";
export { ForwardRef as ReactComponent };